import { useState } from "react";
import { Button } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRotateLeft } from "@fortawesome/free-solid-svg-icons";
import { FormattedMessage, useIntl } from "react-intl";
import { toast } from "react-toastify";
import axios from "../../services/api/api";
import { formatServiceError } from "../../Utilities/serviceErrorHelper";
import { TOAST_CONFIG } from "../../Utilities/toastConfig";

// Återställer en raderad användare med ett anrop. Servern kontrollerar klassen, avstämmer
// kurserna och tar bort låset i auth.
export default function ButtonRestoreUser({ email, onRestored }) {
  const intl = useIntl();
  const [isRestoring, setIsRestoring] = useState(false);

  const restore = async () => {
    setIsRestoring(true);

    try {
      const response = await axios.post(
        `/User/SetDeleted?email=${encodeURIComponent(email)}&isDeleted=false`,
      );
      const name = response?.data?.result?.name;

      if (name) {
        toast.success(
          intl.formatMessage({ id: "RestoreUserDone" }, { name }),
          TOAST_CONFIG,
        );
      } else {
        toast.warn(
          intl.formatMessage({ id: "ServerResponseUnexpected" }),
          TOAST_CONFIG,
        );
      }

      onRestored();
    } catch (err) {
      toast.warn(formatServiceError(intl, err?.response?.data), TOAST_CONFIG);
    } finally {
      setIsRestoring(false);
    }
  };

  return (
    <Button
      outline
      size="sm"
      color="primary"
      disabled={isRestoring}
      onClick={restore}
    >
      <FontAwesomeIcon icon={faRotateLeft} className="me-1" />
      <FormattedMessage id="Restore" />
    </Button>
  );
}
